import { isEqual } from 'lodash';

/**
 * Returns true when refreshed server data changed for the form's current
 * record. A different record already remounts through its record-based key.
 */
export function shouldRemountFormForServerData<TContext extends { id: string }>(
  current: TContext | undefined,
  next: TContext
) {
  return current?.id === next.id && !isEqual(current, next);
}
